<template>
  <div class="main">
    <div class="header">
      <div class="logo">
        <img src="../../assets/images/logo-login.png" alt="logo" style="width: 100%; margin: 0 10px;">
      </div>
      <div class="nav-body">
        <div :class="['nav ' + (index === currentIndex ? 'selectcd' : '')]" v-for="(item, index) in navData" :key="index" @click="showComponents(index)">{{ item.title }}</div>
      </div>
      <div class="right">
        <el-dropdown style="float: right; color: rgba(255,255,255,0.75); margin-right: 20px;">
          <span class="header-btn">
            <span style="color: #fff; margin-right: 10px;">{{ user_name }}</span><i class="fa fa-user-circle" aria-hidden="true" style="font-size: 20px; color: #fff;"></i><i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="showComponents(4)"><i style="padding-right: 8px" class="fa fa-cog"></i>个人中心</el-dropdown-item>
            <el-dropdown-item @click.native="logout"><i style="padding-right: 8px" class="fa fa-key"></i>退出系统</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="app-body">
      <!-- <el-scrollbar style="height: 100%;"> -->
      <div id="mainContainer" class="main-container" v-loading="true" element-loading-text="loading..." element-loading-background="#F9F9F9">
        <div class="layout-right jm-animate">
          <component :is="current" @jump_plan="showComponents(1)"></component>
        </div>
      </div>
      <!-- </el-scrollbar> -->
    </div>
  </div>
</template>

<script>

export default {
  /* global require */
  data() {
    return {
      adminInfo: [],
      current: 'HomeView',
      currentIndex: 0,
      user_name: '我是测试呀',
      navData: [
        {
          title: '首页',
          components: 'HomeView',
          icon: 'fa fa-home'
        },
        {
          title: '推广',
          components: 'PlanView',
          icon: 'fa fa-bell-o'
        },
        {
          title: '报表',
          components: 'DataView',
          icon: 'fa fa-bar-chart'
        },
        {
          title: '受众分析',
          components: 'AddressView',
          icon: 'el-icon-share'
        },
        {
          title: '账户中心',
          components: 'UsersView',
          icon: 'fa fa-user-circle-o'
        }
      ]
    };
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      this.$http.post('/trader/index/getUserInfo').then(res => {
        if (res.code === 200 && res.data.company_name !== undefined) {
          sessionStorage.setItem('user_info', JSON.stringify(res.data));
          this.user_name = res.data.company_name;
        } else {
          this.$message.error('未找到该用户，请联系管理员');
          this.logout();
        }
      });
    },
    showComponents(index) {
      if (this.current !== this.navData[index].components) {
        this.$function.showLoading();
        this.currentIndex = index;
        this.current = this.navData[index].components;
      }
    },
    logout() {
      sessionStorage.removeItem(this.$Config.tokenKey);
      this.$router.push({ path: '/login' });
    }
  },
  mounted() {

  },
  components: {
    HomeView: resolve => require(['@/views/Index/Lists.vue'], resolve),
    PlanView: resolve => require(['@/views/Plan/Lists.vue'], resolve),
    UsersView: resolve => require(['@/views/Users/Lists.vue'], resolve),
    AddressView: resolve => require(['@/views/Address/Lists.vue'], resolve),
    DataView: resolve => require(['@/views/Data/Lists.vue'], resolve)
  }
};
</script>
<style lang="less">
@import '../../assets/css/style.less';
@header-bg: #00A1D6;

.el-menu-item .is-active {
  background-color: #3e85e9 !important;
}

.nav {
  height: 66px;
  line-height: 66px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  padding: 0 20px;
  position: relative;
}

.nav:hover {
  cursor: pointer;
  color: #ffffff;
}

.selectcd {
  color: #fff;
}

.selectcd::after {
  content: '';
  display: inline-block;
  width: 24px;
  height: 4px;
  background: #fff;
  border-radius: 2px;
  position: absolute;
  bottom: 13px;
  left: 50%;
  transform: translateX(-50%);
}

// .el-menu-item:focus,
// .el-menu-item:hover,
// .el-submenu__title:hover {
//   background-color: #FFF !important;
// }

.main {
  display: flex;
  .el-menu:not(.el-menu--collapse) {
    width: 230px;
  }
  .app-body {
    width: 100%;
    height: calc(100% - 66px);
    margin-top: 66px;
    background: #F9F9F9;
    -webkit-transition: margin-left 0.3s ease-in-out;
    transition: margin-left 0.3s ease-in-out;
  }
  .main-container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    position: relative;
    .layout-right {
      width: 100%;
      margin: 0 auto;
    }
  }
}

.header {
  width: 100%;
  position: fixed;
  display: flex;
  height: 66px;
  background-color: @header-bg;
  box-shadow:0px 2px 4px 0px rgba(0, 0, 0, 0.05);
  z-index: 10;
  .logo {
    width: 200px;
    height: 66px;
    overflow: hidden;
    line-height: 50px;
    color: #CED3D9;
    background-color: @header-bg;
    -webkit-transition: width 0.35s;
    transition: all 0.3s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 20px;
    .min {
      display: none;
    }
    &:hover {
      cursor: pointer;
    }
  }
  .nav-body {
    width: calc(100% - 460px);
    display: flex;
    margin-left: 20px;
  }
  .right {
    position: absolute;
    right: 0;
    width: 230px;
  }
  .header-btn {
    overflow: hidden;
    height: 66px;
    display: inline-block;
    text-align: center;
    line-height: 66px;
    cursor: pointer;
    padding: 0 14px;
    .el-badge__content {
      top: 14px;
      right: 7px;
      text-align: center;
      font-size: 9px;
      padding: 0 3px;
      background-color: #00a65a;
      color: #fff;
      border: none;
      white-space: nowrap;
      vertical-align: baseline;
      border-radius: 0.25em;
    }
  }
  .header-btn:hover {
    background-color: @header-bg;
  }
}
.menu {
  border-right: none;
}
.el-menu--vertical {
  min-width: 190px;
}
</style>
